import {
  Component,
  Injector,
  Input,
  Renderer2,
  ElementRef,
  HostListener,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import {
  CargoDto,
  CidadeMicrorregiaoServiceProxy,
  CreateVagaDto,
  CreateVagaEspecialDto,
  EmpresaDto,
  EmpresaServiceProxy,
  EnderecoDto,
  UpdateVagaDto,
  UpdateVagaEspecialDto,
  VagaDto,
  VagaServiceProxy,
} from "@shared/service-proxies/service-proxies";
import { Observable, Subscription } from "rxjs";
import * as moment from "moment";
import { VAGA_CONFIG } from "./vaga-config";
import { FormSobreVagaComponent } from "./form-sobre-vaga/form-sobre-vaga.component";
import { StringUtils } from "@shared/helpers/string-utils";

export const MY_FORMATS = VAGA_CONFIG.MY_FORMATS;
@Component({
  selector: "form-vaga",
  templateUrl: "./form-vaga.component.html",
  styleUrls: ["./form-vaga.component.scss"],
  animations: [appModuleAnimation()],
})
export class FormVagaComponent extends AppComponentBase implements AfterViewInit {
  @ViewChild(FormSobreVagaComponent) formSobreVaga: FormSobreVagaComponent;

  @Input() vagaDuplicada: VagaDto;

  vaga;
  urlRegex = /^(https?):\/\/[^\s]+$/;
  @Input() vagaUpdate;
  @Input() edit = false;
  @Input() labelSave = "Criar vaga";
  @Input() view = false;
  @Input() empresaEspecial = false;
  regiaoGeralId: string;
  nomeCargo: string = "";
  cargo: CargoDto = new CargoDto();
  formInvalido: boolean = false;
  empresaDto: EmpresaDto = new EmpresaDto();
  subscriptions: Subscription[] = [];
  saving = false;
  endereco: EnderecoDto = new EnderecoDto();
  chatScriptElement: any;
  chatStyleElement: any;

  isSmallScreen = false;

  opcaoSelecionada: string = "sobre-vaga";

  constructor(
    injector: Injector,
    private router: Router,
    private _vagaService: VagaServiceProxy,
    private _empresaService: EmpresaServiceProxy,
    private _cidadesMicrorregioesService: CidadeMicrorregiaoServiceProxy,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    super(injector);
  }

  ngOnInit() {
    this.onResize();
    this.loadChatWidget();
    this.getRegiaoGeralId();

    if (this.vagaUpdate) {
      if (this.empresaEspecial) {
        this.vaga = new UpdateVagaEspecialDto();
      } else {
        this.vaga = new UpdateVagaDto();
      }
      this.vaga = this.vagaUpdate;
    }
    else if (this.vagaDuplicada) {
      if (this.empresaEspecial) {
        this.vaga = new CreateVagaEspecialDto();
        this.vaga = CreateVagaEspecialDto.fromJS(this.vagaDuplicada.toJSON());
      } else {
        this.vaga = new CreateVagaDto();
        this.vaga = CreateVagaDto.fromJS(this.vagaDuplicada.toJSON());
      }
    } else {
      if (this.empresaEspecial) {
        this.vaga = new CreateVagaEspecialDto();
      } else {
        this.vaga = new CreateVagaDto();
      }
    }
    this.getEmpresa();
    this.invalidForm();
  }

  ngAfterViewInit() {
    if (this.vagaDuplicada || this.edit) {
      this.formSobreVaga.texto = this.vaga.descricao || "";
      this.formSobreVaga.nomeCargo = this.vaga.cargo?.nome || "";
    }
    this.invalidForm();
  }

  @HostListener("window:resize", [])
  onResize() {
    const width = window.innerWidth;
    this.isSmallScreen = width <= 992 && width >= 767;
  }

  loadChatWidget() {
    this.chatScriptElement = this.renderer.createElement("script");
    this.chatScriptElement.src = VAGA_CONFIG.CHAT_WIDGET_CONFIG.scriptUrl;
    this.chatScriptElement.defer = true;
    this.renderer.appendChild(this.el.nativeElement, this.chatScriptElement);

    this.chatStyleElement = this.renderer.createElement("link");
    this.chatStyleElement.rel = "stylesheet";
    this.chatStyleElement.href = VAGA_CONFIG.CHAT_WIDGET_CONFIG.styleUrl;
    this.renderer.appendChild(this.el.nativeElement, this.chatStyleElement);

    window["CHIPP_APP_URL"] = VAGA_CONFIG.CHAT_WIDGET_CONFIG.appUrl;
    window["CHIPP_APP_ID"] = VAGA_CONFIG.CHAT_WIDGET_CONFIG.appId;
  }

  ngOnDestroy() {
    this.removeChatWidget();
  }

  private removeChatWidget(): void {
    const iframe = document.querySelector("iframe");
    if (iframe) {
      iframe.remove();
    }

    const wid = document.getElementById("chipp-chat-widget");
    if (wid) {
      wid.remove();
    }

    const script = document.getElementById("chat-widget-script");
    if (script) {
      script.remove();
    }

    const link = document.getElementById("chat-widget-link");
    if (link) {
      link.remove();
    }
  }

  private load<T>(
    serviceCall: () => Observable<T>,
    setter: (data: T) => void
  ): void {
    abp.ui.setBusy();
    serviceCall()
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe(setter);
  }

  getEmpresa(): void {
    this.load<EmpresaDto>(
      () => this._empresaService.getAbp(),
      (data) => (this.empresaDto = data)
    );
  }

  save(rascunho: boolean): void {
    abp.ui.setBusy();

    this.prepararVaga(rascunho);

    if (!this.validateFields()) {
      abp.ui.clearBusy();
      return;
    }

    this.setCargo();

    const saveAction = this.getSaveAction(rascunho);

    saveAction
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe(() => {
        this.notify.info(this.l("SavedSuccessfully"));
        this.router.navigateByUrl(
          this.empresaEspecial ? "/empresa-especial/home" : "/empresa/home"
        );
      });
  }

  private prepararVaga(rascunho: boolean): void {
    if (rascunho) {
      this.vaga.rascunho = true;
    }

    if (!this.vaga.dataTerminoInscricoes && this.vaga.dataTermino) {
      this.vaga.dataTerminoInscricoes = this.vaga.dataTermino;
    }

    if (this.empresaEspecial) {
      this.vaga.vagaEspecial = true;
    }

    this.vaga.descricao = this.formSobreVaga?.texto || "";
    this.nomeCargo = this.formSobreVaga?.nomeCargo || "";
    this.cargo = this.formSobreVaga?.cargo || new CargoDto();

    if (!this.vaga.microrregiaoId) {
      this.vaga.microrregiaoId = this.regiaoGeralId;
    }

    if (this.vaga.dataTerminoInscricoes && !this.vaga.dataTermino) {
      this.vaga.dataTermino = this.vaga.dataTerminoInscricoes;
    }

    this.vaga.empresaId = this.empresaDto.id;
  }

  private getSaveAction(rascunho: boolean) {
    if (rascunho) {
      return this.edit
        ? this._vagaService.updateRascunho(this.vaga)
        : this._vagaService.createRascunho(this.vaga);
    }

    if (this.empresaEspecial) {
      return this.edit
        ? this._vagaService.updateVagaEspecial(this.vaga)
        : this._vagaService.createVagaEspecial(this.vaga);
    }

    return this.edit
      ? this._vagaService.update(this.vaga)
      : this._vagaService.create(this.vaga);
  }

  checkFieldsVaga(useDate: boolean = true) {
    var validation = [
      { condition: this.isNullOrEmpty(this.vaga.cidade) || this.isNullOrEmpty(this.vaga.estado), message: "Entre com o estado e a cidade para a vaga." },
      { condition: this.isNullOrEmpty(this.vaga.tituloVaga), message: "É necessário informar um título para a vaga." },
      { condition: this.isNullOrEmpty(this.vaga.modeloTrabalho), message: "Informe o modelo de trabalho." },
      { condition: this.isNullOrEmpty(this.vaga.horasSemanais), message: "Informe o regime de horas semanais." },
      { condition: this.isNullOrEmpty(this.vaga.salario), message: "Informa o valor do salário." },
      { condition: this.isNullOrEmpty(this.vaga.regimeTrabalho), message: "Informe o regime de trabalho." },
      { condition: this.isNullOrEmpty(this.vaga.quantidadeVagas) || this.vaga.quantidadeVagas === "0", message: "É necessário entrar com a quantidade de vagas disponíveis." },

      { condition: this.isNullOrEmpty(this.formSobreVaga?.nomeCargo), message: "Informe o nome do cargo." },
      { condition: this.isNullOrEmpty(this.formSobreVaga?.texto), message: "Escreva uma breve descrição da vaga." },
    ];

    var dataValidations = [
      { condition: this.isNullOrEmpty(this.vaga.dataInicio) && !this.vaga.rascunho, message: "Informe uma data de início para a vaga." },
      { condition: !this.isNullOrEmpty(this.vaga.dataTerminoInscricoes) && !this.isEndDateValid(this.vaga.dataInicio, this.vaga.dataTerminoInscricoes), message: "Informe uma data de término das inscrições válida." },
      { condition: !this.isNullOrEmpty(this.vaga.dataTermino) && !this.isEndDateValid(this.vaga.dataInicio, this.vaga.dataTermino), message: "Informe uma data de término das contratações válida." },
      { condition: !this.edit && !this.isDateValid(this.vaga.dataInicio), message: "Informe uma data de início das inscrições válida." },
      { condition: !this.edit && !this.isStartDateValid(), message: "Informe uma data de início das inscrições válida." },
      { condition: !this.isNullOrEmpty(this.vaga.dataTerminoInscricoes) && !this.isNullOrEmpty(this.vaga.dataTermino) && this.isInvalidEndSubscriptionDate(), message: "A data de término das inscrições não pode ser maior que a data de término da vaga." }
    ]

    if(useDate)
      validation.push(...dataValidations);

    return validation;
  }

  checkFieldsVagaEspecial(useDate: boolean = true) {
    var validation = [
      { condition: this.vaga.estado && StringUtils.isNullOrEmpty(this.vaga.cidade), message: "Selecione uma cidade." },
      { condition: StringUtils.isNullOrEmpty(this.vaga.tituloVaga), message: "É necessário informar um título para a vaga." },
      { condition: StringUtils.isNullOrEmpty(this.vaga.urlVaga), message: "É necessário informar o link externo da vaga." },
      { condition: !StringUtils.isNullOrEmpty(this.vaga.urlVaga) && !this.urlRegex.test(this.vaga.urlVaga), message: "A URL fornecida não é válida." },
      { condition: !StringUtils.isNullOrEmpty(this.vaga.quantidadeVagas) && this.vaga.quantidadeVagas === "0", message: "É necessário entrar com a quantidade de vagas disponíveis." },
      { condition: this.vaga.exibirVagas && (StringUtils.isNullOrEmpty(this.vaga.quantidadeVagas) || this.vaga.quantidadeVagas === "0"), message: "É necessário entrar com a quantidade de vagas disponíveis." },
    ];

    var dataValidations = [
       { condition: this.isNullOrEmpty(this.vaga.dataInicio) && !this.vaga.rascunho, message: "Informe uma data de início para a vaga." },
       { condition: !this.isNullOrEmpty(this.vaga.dataTerminoInscricoes) && !this.isEndDateValid(this.vaga.dataInicio, this.vaga.dataTerminoInscricoes), message: "Informe uma data de término das inscrições válida." },
       { condition: !this.isNullOrEmpty(this.vaga.dataTermino) && !this.isEndDateValid(this.vaga.dataInicio, this.vaga.dataTermino), message: "Informe uma data de término das contratações válida." },
       { condition: !this.edit && !this.isDateValid(this.vaga.dataInicio), message: "Informe uma data de início das inscrições válida." },
       { condition: !this.edit && !this.isStartDateValid(), message: "Informe uma data de início das inscrições válida." },
       { condition: !this.isNullOrEmpty(this.vaga.dataTerminoInscricoes) && !this.isNullOrEmpty(this.vaga.dataTermino) && this.isInvalidEndSubscriptionDate(), message: "A data de término das inscrições não pode ser maior que a data de término da vaga." }
    ]

    if(useDate)
      validation.push(...dataValidations);

    return validation;
  }

  private validateFields(): boolean {

    let validations = this.empresaEspecial ? this.checkFieldsVagaEspecial() : this.checkFieldsVaga();
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  isStartDateValid(): boolean {
    return (
      !moment(this.vaga.dataInicio).isBefore(moment().startOf("day")) &&
      moment(this.vaga.dataInicio).isBefore(
        moment().startOf("day").add(1, "year")
      )
    );
  }

  isNullOrEmpty(value: any): boolean {
    return value === undefined || value === null || value === "";
  }

  isDateValid(date: any): boolean {
    return (
      !moment(date).isBefore(moment().startOf("day")) &&
      moment(date).isBefore(moment().startOf("day").add(1, "year"))
    );
  }

  isEndDateValid(startDate: any, endDate: any): boolean {
    return (
      endDate !== undefined &&
      !moment(startDate).isAfter(moment(endDate)) &&
      moment(endDate).isBefore(moment().add(1, "year"))
    );
  }

  private isInvalidEndSubscriptionDate(): boolean {
    return moment(this.vaga.dataTerminoInscricoes).isAfter(
      moment(this.vaga.dataTermino)
    );
  }

  private setCargo() {
    const isEditing =
      this.edit && this.nomeCargo !== this.vagaUpdate?.cargo?.nome;
    const isNewOrModifiedCargo = !this.edit || isEditing;

    if (isNewOrModifiedCargo) {
      const isExistingCargo = this.cargo && this.cargo.nome === this.nomeCargo;

      if (isExistingCargo) {
        this.vaga.cargo = this.cargo;
      } else {
        this.vaga.cargo = new CargoDto();
        this.vaga.cargo.nome = this.nomeCargo;
      }

      this.vaga.cargoId = undefined;
    }
  }

  selecionarOpcao(opcao: string) {
    this.opcaoSelecionada = opcao;
  }

  private getRegiaoGeralId(): void {
    this._cidadesMicrorregioesService.getRegiaoGeralId().subscribe((id) => {
      this.regiaoGeralId = id;
    });
  }

  invalidForm() {
    let validation = this.empresaEspecial ? this.checkFieldsVagaEspecial(false) : this.checkFieldsVaga(false);
    var result = validation.find(x => x.condition);
    this.formInvalido = result?.condition;
  }
}
